import { ADFOX_SCRIPT_SRC } from '../config/a51';

export interface AdfoxImageCreative {
  imageUrl: string;
  reference?: string;
  target?: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
}

export interface AdfoxRenderData extends Partial<AdfoxImageCreative> {
  attributes?: Partial<AdfoxImageCreative>;
}

export interface AdfoxCreateOptions {
  ownerId: number;
  containerId: string;
  params: Record<string, number | string>;
  onRender: (data?: AdfoxRenderData) => void;
  onStub: () => void;
  onError: (error?: unknown) => void;
}

interface AdfoxContextQueue {
  push: (callback: () => void) => unknown;
}

export interface AdfoxCode {
  create: (options: AdfoxCreateOptions) => void;
  destroy?: (containerId: string) => void;
}

declare global {
  interface Window {
    Ya?: { adfoxCode?: AdfoxCode };
    yaContextCb?: AdfoxContextQueue;
  }
}

function appendAdfoxScript(): void {
  if (document.querySelector(`script[src="${ADFOX_SCRIPT_SRC}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = ADFOX_SCRIPT_SRC;
  document.head.append(script);
}

export function whenAdfoxReady(callback: (adfoxCode: AdfoxCode) => void): void {
  const contextQueue: AdfoxContextQueue = window.yaContextCb ?? new Array<() => void>();

  window.yaContextCb = contextQueue;
  contextQueue.push(() => {
    const adfoxCode = window.Ya?.adfoxCode;

    if (adfoxCode) {
      callback(adfoxCode);
    }
  });
  appendAdfoxScript();
}

export function destroyAdfox(containerId: string): void {
  window.Ya?.adfoxCode?.destroy?.(containerId);
}
